module.exports = __webpack_public_path__ + "img/frame (130).9de7e4e4.jpg";